export default __webpack_public_path__ + "static/media/gcash.e44525b4.png";